<p>alertbox works!</p>
<div class ="backdrop"></div>
<div class="alert-box">
    <div>{{error}}</div>
    <div class="alert-box-actions text-right">
        <h3>Do you sure to overwrite ?</h3>
        <button type="button" class="btn btn-primary">Yes Overwrite</button>
        <button type="button" class="btn btn-primary">Cancel</button>
    </div>
</div>